class BasePart
  constructor: (audioContext) ->
    @audioContext = audioContext

  _createInstance: ->
    throw "Not implemented"

  setValue: ->
    throw "Not implemented"

  getDestination: ->
    throw "Not implemented"

  getInterface: ->
    throw "Not implemented"

  connect: (destination) ->
    if destination?
      destination = destination.getInstance() if destination.getInstance?
      @destination = @getInterface().connect(destination)

  disconnect: ->
    @getInterface().disconnect()
    @destination = undefined

export default BasePart
